import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core'
import { provideRouter, TitleStrategy } from '@angular/router'
import { routes } from './app.routes'
import { AppTitleStrategy } from './app-title-strategy'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideTranslateService } from '@ngx-translate/core'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental'
import { authInterceptor } from './auth.interceptor'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { enGB } from 'date-fns/locale'
import { provideQueryDevTools } from '@ngneat/query-devtools'
import { environment } from '../environments/environment'
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip'
import { CustomDateFnsModule } from './custom-date.module'
import { DurationPipe } from './duration.pipe'
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common'
import localeGb from '@angular/common/locales/en-GB'
import { provideCharts, withDefaultRegisterables } from 'ng2-charts'
import * as Sentry from '@sentry/angular'
import { SentryService } from './sentry.service'

registerLocaleData(localeGb)

const queryDevToolProvider = environment.production ? [] : [provideQueryDevTools()]

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideTanStackQuery(new QueryClient()),
    ...queryDevToolProvider,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_DATE_LOCALE, useValue: enGB },
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 500 } },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'd MMM y HH:mm' } },
    provideTranslateService({
      defaultLanguage: 'en_US',
      useDefaultLang: true,
      fallbackLang: 'en_US',
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    }),
    importProvidersFrom(CustomDateFnsModule),
    DurationPipe,
    provideCharts(withDefaultRegisterables()),
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    provideAppInitializer(() => {
      inject(SentryService)
    }),
  ],
}
